export { default } from "./src/enhanced-banner";

export type { UniformEnhancedBannerProps } from "./src/enhanced-banner";
